<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getVenueHireDetailsTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionVenueHireDetail && permissionVenueHireDetail.permission_id === permission.readWrite"
          @click.native="createVenueHireDetails" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
                <template v-if="header.icon">
                  <a @click="sortDataTable(header.id)">
                    <v-icon class="fas fa-caret-down"
                            v-if="sort == 'desc'"
                            style="font-size: 12px"></v-icon>
                    <v-icon class="fas fa-caret-up"
                            v-if="sort == 'asc'"
                            style="font-size: 12px"></v-icon>
                  </a>
                </template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.floor ? item.floor.floor_name : "" }}</td>
              <td>{{ item.venue_hire ? item.venue_hire.name_th : "" }}</td>
              <td>{{ item.name_th }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>
                <a @click="showVenueHireDetailsData(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import IconPencil from "../../../components/Icon/icon-pencil";
import CircleButton from "../../../components/Button/CircleButton";
import InputTextField from "../../../components/Input/InputTextField";
import InputSearch from "../../../components/Input/InputSearch";
import Paginate from "../../../components/Layout/Paginate";
import {permissionVenueHireDetail, role} from "../../../util/Permission";
import {mapState} from "vuex";
import Loading from 'vue-loading-overlay';
import Swal from 'sweetalert';

export default {
  name: "VenueHireDetailsTable",
  components: {Paginate, InputSearch, InputTextField, CircleButton, IconPencil, Loading },
  data() {
    return {
      title: "Venue hire detail",
      isLoading: false,
      headers: [
        { id: 1, text: "No." ,icon : null},
        { id: 2, text: "Floor" ,icon : null},
        { id: 33, text: "Venue hire" ,icon : true},
        { id: 4, text: "Venue hire detail" ,icon : null},
        { id: 22, text: "Update date" ,icon : true},
        { id: 6, text: "edit" ,icon : null}
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      },
      permission : null,
      search : '',
      sort :'desc',
      sort_venue_hire : 'desc',
      sort_date : 'desc',
    };
  },
  computed: {
    permissionVenueHireDetail,
  },
  created() {
    this.permission = role;
    this.getVenueHireDetailsTable(1);
  },
  methods: {
    goToVenueHireDetailsEdit() {
      this.$router.push("/venue-hire-details/edit");
    },
    getVenueHireDetailsTable(page) {
      this.isLoading = true;
      this.$store.dispatch("VenueHireDetails/getVenueHireDetails", {
        page ,
        search : this.search,
        sort_venue_hire : this.sort_venue_hire,
        sort_date : this.sort_date,
      }).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    async changePage(val){
      this.isLoading = true;
      this.dataPaginate.current_page = val;
      await this.getVenueHireDetailsTable(this.dataPaginate.current_page);
      this.isLoading = false;
    },
    showVenueHireDetailsData(id) {
      this.isLoading = true;
      this.$store.dispatch("VenueHireDetails/showVenueHireDetails", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("VenueHireDetails/setFormVenueHireDetails", res.result).then(() => {
            this.goToVenueHireDetailsEdit();
          });
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    createVenueHireDetails() {
      this.$store.dispatch("VenueHireDetails/clearFormData").then(() => {
        this.goToVenueHireDetailsEdit();
      });
    },
    searchInput(val){
      this.search = val;
    },
    sortDataTable(header_id){
      this.sort = this.sort == 'desc' ? 'asc' : 'desc';
      if(header_id === 33){ //sort by branch
        this.sort_venue_hire = this.sort_venue_hire == 'desc' ? 'asc' : 'desc';
      }
      if(header_id === 22){ //sort by updated_at
        this.sort_date = this.sort_date == 'desc' ? 'asc' : 'desc';
      }
      this.getVenueHireDetailsTable(1);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/table.css";
@import "../../../assets/css/variables";
.branch-data {
  background-color: $background-theme;
  margin: 20px;
}
</style>
